export default __webpack_public_path__ + "static/media/f1.92623b5d.mp4";